type Color = string;

export type ITheme = {
	base?: 'light' | 'dark'; // Default light
	shape?: {
		cornerSize?: number; // Default 2
	};
	colors?: {
		primary?: Color;
		background?: Color;
		control?: Color;
	};
	widgets?: {
		editAddress?: {
			colors?: {
				background?: Color;
				text?: Color;
			};
		};
		buttonClose?: {
			colors?: {
				background?: Color | '@primary';
				text?: Color;
				icon?: Color;
			};
			icon?: 'none' | 'exit_to_app' | 'close' | 'cancel';
			text?: string;
		};
		progress?: {
			color?: Color | '@primary';
		};
	};
};

export const VITheme = {
	base: { '?string': ['light', 'dark'] },
	shape: {
		'?object': {
			cornerSize: '?number',
		},
	},
	colors: {
		'?object': {
			primary: '?string',
			background: '?string',
			control: '?string',
		},
	},
	widgets: {
		'?object': {
			editAddress: {
				'?object': {
					colors: {
						'?object': {
							background: '?string',
							text: '?string',
						},
					},
				},
			},
			buttonClose: {
				'?object': {
					colors: {
						'?object': {
							background: '?string',
							text: '?string',
							icon: '?string',
						},
					},
					icon: { '?string': ['none', 'exit_to_app', 'close', 'cancel'] },
					text: '?string',
				},
			},
			progress: {
				'?object': {
					color: '?string',
				},
			},
		},
	},
};

/** @deprecated */
export interface IDeprecatedOpenLinkOptions {
	acl?: RegExp[];
	aclMode?: 'blacklist' | 'whitelist';
	readOnlyAddressBar?: boolean;
	idleTimeout?: number; // milliseconds
	theme?: ITheme;
}

/**
 * Interface defines the options for opening a link in the browser.
 */
interface IOpenLinkOptions {
	/*
	 * Specifies the domains that are allowed or blocked in the browser.
	 */
	aclDomains?: string[];
	/*
	 * Specifies the access control mode for the browser.
	 */
	aclMode?: 'blacklist' | 'whitelist';
	/*
	 * If set, the address bar will be read-only and users won't be able to change the URL.
	 * This is useful for kiosk mode or controlled environments.
	 * @default false
	 */
	readOnlyAddressBar?: boolean;
	/*
	 * If set, the browser will close after the specified time of inactivity.
	 * @default 0 (no timeout)
	 */
	idleTimeout?: number; // milliseconds
	/*
	 * Size and position of the browser window. Defaults to fullscreen.
	 * @default { x: 0, y: 0, width: screen.width, height: screen.height }
	 */
	coordinates?: {
		x: number;
		y: number;
		width: number;
		height: number;
	};
	/*
	 * Specify custom UI theme. (Android only)
	 */
	theme?: ITheme;
	/*
	 * Headless mode allows the browser to run without a visible UI.
	 * @default false
	 */
	headlessMode?: boolean;
	/*
	 * Clear cache after the browser closes.
	 * @default true if headlessMode is false, else true
	 */
	clearData?: boolean;
	/*
	 * Whether the user can manually close the browser.
	 * @default true if headlessMode is false, else true
	 */
	canUserClose?: boolean;
	/**
	 * Method of opening the link.
	 * @default 'native'
	 */
	method?: 'native' | 'iframe';
}

export default IOpenLinkOptions;

export const VIOpenLinkOptions = {
	aclDomains: { '?array': 'string' },
	aclMode: { '?string': ['blacklist', 'whitelist'] },
	readOnlyAddressBar: '?boolean',
	idleTimeout: '?number',
	coordinates: {
		'?object': {
			x: 'number',
			y: 'number',
			width: 'number',
			height: 'number',
		},
	},
	theme: { '?object': VITheme },
	headlessMode: '?boolean',
	clearData: '?boolean',
	canUserClose: '?boolean',
	method: { '?string': ['native', 'iframe'] },
};
